import React, { useEffect, useState, useContext } from 'react'
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import OpenInNewSharpIcon from '@mui/icons-material/OpenInNewSharp';
import ReactTable from 'components/common/ReactTable';
import { useForm, Controller } from 'react-hook-form';
import SearchableDropdown from 'components/common/SearchableDropdown';
import ReactDatePicker from 'components/common/ReactDatePicker';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { checkModulePermission } from 'components/common/helper-function/ModulePermissionCheck';
import './report.css'
import { getListOfVisitortype } from 'services/adminmoduleService'
import { listidenti } from 'services/manageEventsService'
import { errorMessage } from 'components/common/helper-function/catchErrorMessage';
import { loaderContext } from 'context/Context';
import { bypassreportlist } from 'services/reportsService'
import moment from 'moment';
import { getListOfregister } from 'services/adminmoduleService'





function BypassReport() {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    const { isLoading, setIsLoading } = useContext(loaderContext)

    const { t } = useTranslation();
    const navigate = useNavigate();
    const [bypassreportdata, setBypassReportData] = useState([]);

    const [bypassOption, setBypassOption] = useState([]);
    const [visitorTypeOption, setVisitorTypeOption] = useState([]);
    const [visitoridtypeOption, setVisitorIdTypeOption] = useState([]);
    // const [dateRange, setDateRange] = useState([null, null]);
    // const [startDate, endDate] = dateRange;

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    useEffect(async () => {
        checkModulePermission("ByPass Report")
        setIsLoading(true)
        try {
            const { data: visitortype } = await getListOfVisitortype()
            const { data: identitype } = await listidenti()
            const { data: register } = await getListOfregister()
            const { data } = await bypassreportlist({})
            setVisitorTypeOption(visitortype?.data?.map((visitor) => ({ label: visitor?.name, value: visitor?.id })))
            setVisitorIdTypeOption(identitype?.data?.map((ident) => ({ label: ident?.name, value: ident?.id })))
            setBypassOption(register?.data?.map((reg) => ({ label: reg?.name, value: reg?.id })))
            setBypassReportData(data?.data)
        } catch (error) {
            errorMessage(error)
        }
        setIsLoading(false)
    }, [])

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
        control,
        setValue,
        setError,
        clearErrors,
        watch
    } = useForm();



    const columns = [

        {
            Header: t('bypassreport.bypassreporttable.name'),
            accessor: 'visitor_name',
            Cell: ({ row }) => {
                return row?.original?.visitor_name ? row?.original?.visitor_name : "--"
            }
        },
        {
            Header: t('bypassreport.bypassreporttable.mobileno'),
            accessor: 'phone_number',
            Cell: ({ row }) => {
                return row?.original?.phone_number ? `${row?.original?.country_code}-${row?.original?.phone_number}` : '--'
            }
        },
        {
            Header: t('bypassreport.bypassreporttable.idno'),
            accessor: 'document_id_number',
            Cell: ({ row }) => {
                return row?.original?.document_id_number ? row?.original?.document_id_number : "--"
            }
        },
        {
            Header: t('bypassreport.bypassreporttable.idtype'),
            accessor: 'document_id_type',
            Cell: ({ row }) => {
                return row?.original?.document_id_type ? row?.original?.document_id_type : "--"
            }
        },
        {
            Header: t('bypassreport.bypassreporttable.visitorby'),
            accessor: 'visitor_type',
            Cell: ({ row }) => {
                return row?.original?.visitor_type ? row?.original?.visitor_type : "--"
            }
        },
        {
            Header: t('bypassreport.bypassreporttable.bypassedby'),
            accessor: 'bypassed_by',
            Cell: ({ row }) => {
                return row?.original?.bypassed_by ? row?.original?.bypassed_by : "--"
            }
        },
        {
            Header: t('bypassreport.bypassreporttable.bypassedon'),
            accessor: 'bypassed_on',
            Cell: ({ row }) => {
                return row?.original?.bypassed_on ? moment.utc(row?.original?.bypassed_on).local().format(process.env.REACT_APP_SET_DATE_TIME_FORMAT) : '--'
            }
        },
    ];

    const onSubmit = async (bypassdata) => {
        console.log(bypassdata);
        setIsLoading(true)

        if (bypassdata?.bypassed_by || bypassdata?.visitor_type || bypassdata?.visitor_id_type || (startDate && endDate)) {
            try {
                bypassdata.bypassed_by = bypassdata.bypassed_by?.value
                bypassdata.visitor_type = bypassdata.visitor_type?.value
                bypassdata.visitor_id_type = bypassdata.visitor_id_type?.value
                if (startDate && endDate) {
                    bypassdata.date_range = `${moment(startDate).format(process.env.REACT_APP_FILTER_DATE)}-${moment(endDate).format(process.env.REACT_APP_FILTER_DATE)}`;
                }
                const { data } = await bypassreportlist(bypassdata)
                setBypassReportData(data?.data)
            } catch (e) {
                if (e.response.data) {
                    if (Array.isArray(e.response.data.message)) {
                        e.response.data.message.map(errors => toast.error(errors, toastConfig))
                    } else {
                        toast.error(e.response.data.message, toastConfig)
                    }
                } else {
                    toast.error(e.message, toastConfig)
                }
            }
        }
        setIsLoading(false)

    };

    const downloadPDF = () => {
        const docDefinition = {
            pageOrientation: 'landscape',
            pageSize: { width: 700, height: 600 },
            content: [
                { text: 'User Data', style: 'header' },
                { text: '\n' },
                {
                    table: {
                        headerRows: 1,
                        widths: Array.from({ length: columns.length }, () => 'auto'),
                        body: [
                            columns.map((column) => column.Header),
                            ...bypassreportdata.map((row) => columns.map((column) => {
                                if (column.accessor === 'bypassed_on') {
                                    return row[column.accessor] && row[column.accessor] != "" ? moment.utc(row[column.accessor]).local().format(process.env.REACT_APP_SET_DATE_TIME_FORMAT) : '--';
                                } else if (column.accessor === 'phone_number') {
                                    const phoneNumber = row['phone_number'];
                                    const countryCode = row['country_code'];
                                    return phoneNumber && phoneNumber !== "" ? `${countryCode} ${phoneNumber}` : '--';
                                } else {
                                    return row[column.accessor] !== undefined ? row[column.accessor] : '';
                                }
                            })),

                        ],
                    },
                },
            ],
            defaultStyle: {
                actionHeader: false,
            },
            styles: {
                header: {
                    fontSize: 18,
                    bold: true,
                },
            },
        };

        const pdfDocGenerator = pdfMake.createPdf(docDefinition);
        pdfDocGenerator.download('bypass_data.pdf');
    };

    const downloadCSV = () => {
        const csvData = [
            columns.map((column) => column.Header),
            ...bypassreportdata.map((row) => columns.map((column) => {
                if (column.accessor === 'bypassed_on') {
                    return row[column.accessor] && row[column.accessor] != "" ? moment.utc(row[column.accessor]).local().format(process.env.REACT_APP_SET_DATE_TIME_FORMAT) : '--';
                } else if (column.accessor === 'phone_number') {
                    const phoneNumber = row['phone_number'];
                    const countryCode = row['country_code'];
                    return phoneNumber && phoneNumber !== "" ? `${countryCode} ${phoneNumber}` : '--';
                } else {
                    return row[column.accessor] !== undefined ? row[column.accessor] : '';
                }
            })),
        ]
            .map((row) => row.join(','))
            .join('\n');

        const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8' });
        saveAs(blob, 'bypass_data.csv');
    };


    return (
        <div className="row g-3 mb-3">
            {/* <div className=""> */}
            <div className="card overflow-hidden mb-3 col-sm-12 col-md-12 col-lg-9 data-table" style={{ height: "fit-content" }}>
                <div className="card-header">
                    <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-4 heading-text">
                            <h3 className="heading-color fw-600 mb-0">
                                {t('bypassreport.heading')}
                            </h3>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-8 table-btn" >
                            <button
                                className="btn btn-primary btn-sm float-end"
                                onClick={() => downloadPDF()}
                            >
                                <OpenInNewSharpIcon />
                                {/* <FontAwesomeIcon icon="plus" /> */}
                                <span className="ms-1 d-sm-inline ">
                                    {t('bypassreport.exportpdfbtn')}
                                </span>
                            </button>

                            <button
                                className="btn mx-1 btn-primary btn-sm float-end"
                                onClick={() => downloadCSV()}
                            >
                                <OpenInNewSharpIcon />
                                {/* <FontAwesomeIcon icon="plus" /> */}
                                <span className="ms-1 d-sm-inline ">
                                    {t('bypassreport.exportcsvbtn')}
                                </span>
                            </button>
                        </div>

                        <div className="col-12">
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="card-body pt-0">
                    <ReactTable
                        columns={columns}
                        data={bypassreportdata}
                        pageSizeOption={[5, 10, 15, 20]}
                        headerClass="btn-primary"
                        isSearchBoxVisible
                        widthClass="table-width"
                        ispaginationvisible={true}
                    />
                </div>
            </div>


            <div className='card overflow-hidden mb-3 col-sm-12 col-md-12 col-lg-2 filter-table' style={{ padding: "0rem .8rem 0rem .8rem", height: "fit-content" }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className='row' style={{ backgroundColor: "rgb(247, 247, 247)", paddingTop: ".8rem", height: "3rem", color: "black", marginBottom: '1rem' }}>
                        <span>{t('bypassreport.filterheading')}</span>
                    </div>

                    <div className="form-group col-12 mb-3">
                        <label>
                            {t('bypassreport.filterform.bypassby')}
                        </label>
                        <Controller
                            name="bypassed_by"
                            control={control}
                            // rules={{ required: true }}
                            render={({ field: { value, onChange } }) => (
                                <SearchableDropdown
                                    value={value}
                                    onChange={onChange}
                                    options={bypassOption}
                                    hasError={errors.bypassedby}
                                    placeholder={t('bypassreport.placeholder.bypassby')}
                                />
                            )}
                        />
                        {/* {errors.bypassedby && (
                            <small>
                                {errors.bypassedby.type === 'required' && (
                                    <span className="text-danger">
                                        {t('bypassreport.error.bypasserror')}
                                    </span>
                                )}
                            </small>
                        )} */}
                    </div>
                    <div className="form-group col-12 mb-3">
                        <label>
                            {t('bypassreport.filterform.visitortype')}
                        </label>
                        <Controller
                            name="visitor_type"
                            control={control}
                            // rules={{ required: true }}
                            render={({ field: { value, onChange } }) => (
                                <SearchableDropdown
                                    value={value}
                                    onChange={onChange}
                                    options={visitorTypeOption}
                                    hasError={errors.visitortype}
                                    placeholder={t('bypassreport.placeholder.visitortype')}
                                />
                            )}
                        />
                        {/* {errors.visitortype && (
                            <small>
                                {errors.visitortype.type === 'required' && (
                                    <span className="text-danger">
                                        {t('bypassreport.error.visitortypeerror')}
                                    </span>
                                )}
                            </small>
                        )} */}
                    </div>
                    <div className="form-group col-12 mb-3">
                        <label>
                            {t('bypassreport.filterform.visitoridtype')}
                        </label>
                        <Controller
                            name="visitor_id_type"
                            control={control}
                            // rules={{ required: true }}
                            render={({ field: { value, onChange } }) => (
                                <SearchableDropdown
                                    value={value}
                                    onChange={onChange}
                                    options={visitoridtypeOption}
                                    hasError={errors.visitortype}
                                    placeholder={t('bypassreport.placeholder.visitoridtype')}
                                />
                            )}
                        />
                        {/* {errors.visitoridtype && (
                            <small>
                                {errors.visitoridtype.type === 'required' && (
                                    <span className="text-danger">
                                        {t('bypassreport.error.visitoridtype')}
                                    </span>
                                )}
                            </small>
                        )} */}
                    </div>
                    <div className="form-group col-12 mb-3">
                        <label>
                            {t('bypassreport.filterform.daterange')}
                        </label>
                        <Controller
                            name="date_range"
                            control={control}
                            // rules={{ required: true }}
                            render={({ field: { value, onChange } }) => (
                                <>
                                    {/* <ReactDatePicker

                                    value={value}
                                    // onChange={onChange}
                                    onChange={(update) => {
                                        setDateRange(update);
                                    }}
                                    placeholder={t(
                                        'bypassreport.placeholder.date'
                                    )}
                                    hasErrors={errors.date}
                                    dateFormat="dd-MM-yyyy"
                                    startDate={startDate}
                                    endDate={endDate}
                                    selectsRange={true}
                                // isClearable={true}
                                /> */}

                                    <ReactDatePicker
                                        selected={startDate}
                                        value={startDate}
                                        onChange={(date) => setStartDate(date)}
                                        placeholder={t('summaryreport.placeholder.startdate')}
                                        dateFormat="dd/MM/yyyy"
                                        selectsStart
                                        startDate={startDate}
                                        endDate={endDate}
                                        maxDate={endDate || undefined}
                                    />
                                    {/* <span className="mx-2">-</span> */}
                                    <br />
                                    <ReactDatePicker
                                        selected={endDate}
                                        value={endDate}
                                        onChange={(date) => setEndDate(date)}
                                        placeholder={t('summaryreport.placeholder.enddate')}
                                        dateFormat="dd/MM/yyyy"
                                        selectsEnd
                                        startDate={startDate}
                                        endDate={endDate}
                                        minDate={startDate || undefined}
                                    />
                                </>
                            )}
                        />
                        {/* {errors.date && (
                            <small>
                                {errors.date.type === 'required' && (
                                    <span className="text-danger">
                                        {t('bypassreport.error.dateerror')}
                                    </span>
                                )}
                            </small>
                        )} */}
                    </div>

                    <div className="text-start col-12">
                        <div className="mb-3 mt-4 text-start">
                            <button type="submit" className="col-lg-12 btn btn-primary me-1">
                                {t('bypassreport.filterform.filterbtn')}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            {/* </div> */}
        </div>
    )
}

export default BypassReport